<template>
    <div class="dialogBilling">
        <div class="nav">
            <van-nav-bar title="账单记录" right-text="交费历史" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight"/>
        </div>
        <div style="padding-top:45px"></div>
        <!-- 上方的选择 -->
        <div style="padding:0 15px" class="houseS">
            <van-field v-model="room" is-link readonly label="选择房间" placeholder="请选择交费房屋" @click="residentialshow=true" />
            <van-popup v-model:show="residentialshow" position="bottom" :style="{ height: '50%' }">
                <van-picker @cancel="residentcancel" @confirm="onConfirm" show-toolbar title="选择交费房屋" value-key='housename' :columns="residentcolum" />
            </van-popup>
        </div>
        <!--  -->
        <div>
            <!-- <van-col span='24' style="text-align:center;padding:10px 0 0 0" v-if="isAll">
                <van-button type="primary" size="small" @click="checkAll" block>{{!isCancel?'全 选':'取 消'}}</van-button>
            </van-col> -->
            <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
            <!-- <van-list v-model:loading="loading" v-model:error="error" success-text="刷新成功"  :finished="finished"  @load="onLoad" > -->
            <van-cell is-link style="display:flex;align-items:center" v-for="(item) in list" :key="item" >
                <template #title>
                    <div style="display:flex;align-items:center" >
                        <van-checkbox-group v-if="isShow" ref="checkboxGroup" v-model="result" style="padding:0 4px;vertical-align: middle;"  >
                            <van-checkbox :name="item" @click="changeCheck(item)"></van-checkbox>
                        </van-checkbox-group>
                        <!-- <i :class="item.feename.indexOf('水')>-1?'iconfont icon-shuifei':item.feename.indexOf('电')>-1?'iconfont icon-dianfei':item.feename.indexOf('车')>-1?'iconfont icon-icon-test':'iconfont icon-qita'" :style="item.feename.indexOf('水')>-1?'font-size:36px;color:blue;padding-left:15px':'font-size:36px;color:green;padding-left:15px'"></i> -->
                        <i :class="item.iconfont" style="font-size:36px;padding-left:0px" @click="openDetail(item)"></i>
                        <div style="font-size:15px;padding-left:6px" @click="openDetail(item)">
                            <div style="font-weight:bold" >{{item.feename}}</div>
                            <div style="font-size:13px;color:gray">费用期:{{item.createdate}}</div>
                        </div>
                    </div>
                </template>
                <template #right-icon>
                    <div style="display:flex;align-items:center" @click="openDetail(item)">
                        <div style="font-size:13px;font-weight:bold;color:red">{{((item.feeamount*10000+item.latefees*10000+item.feeshare*10000)/10000).toFixed(2)}}</div>
                        <!-- <van-icon style="padding-left:6px" name="warning-o" class="search-icon" @click="openDetail(item)"/> -->
                    </div>
                </template>
            </van-cell>
            <!-- </van-list> -->
            <!-- </van-pull-refresh> -->
            <div style="clear:both"></div>
        </div>
        <div style="padding-top:80px;"></div>
        <van-submit-bar v-if="isShow2" :disabled='totalCost==0' :price="totalCost*100" button-text="结 算" @submit="onSubmit">
            <van-checkbox v-if="isAll" style="height:100%" v-model="CheckSize" @click="ClickAll">全选</van-checkbox>
        </van-submit-bar>
        <!-- <div style="height:60px" class="flex_button" v-if="isShow2">
            <div style="float:left;font-size:13px;height:100%;width:20%;box-sizing:border-box;padding-left:10px">
                <van-checkbox v-if="isAll" style="height:100%" v-model="CheckSize" @click="ClickAll">全选</van-checkbox>
            </div>
            <div style="height:100%;float:right;width:25%;text-align:right">
                <van-button :disabled='totalCost==0' style="height:100%;" type="danger" @click="payMent">支 付</van-button>
            </div>
            <div style="font-size:13px;float:right;height:60px;width:55%;text-align:right">
                    <div style="font-size:13px;height:20px;line-height">余额:<span style="color:red">￥{{balance}}</span></div>
                    <div style="font-size:13px;height:20px;line-height">费用合计:<span style="color:red">￥{{totalCost}}</span></div>
                    <div style="font-size:13px;height:20px;line-height">应交费用:<span style="color:red">￥{{feesPayable}}</span></div>
            </div>
            
            <div style="clear:both"></div>
        </div> -->
        <!-- 弹框 -->
        <!-- <van-popup style="width:80%" v-model:show="showContent" :round='true' :close-on-popstate='true'> -->
        <van-dialog v-model:show="showContent" title="详情" showConfirmButton>
            <div style="padding:16px 20px;font-size:13px">
                <van-row style="line-height:20px;text-align:left">
                    <van-col v-if="detailObj.startnum!=null&&detailObj.startnum!=''" span='12'>表初：{{detailObj.startnum}}</van-col>
                    <van-col v-if="detailObj.endnum!=''&&detailObj.endnum!=null" span='12'>表末：{{detailObj.endnum}}</van-col>
                    <van-col v-if="detailObj.amount!=null" span='12'>用量：{{detailObj.amount}}</van-col>
                    <van-col span='12'>单价：{{detailObj.price}}元</van-col>
                    <van-col v-if="detailObj.feeamount!=''&&detailObj.feeamount!=null" span='12'>费用金额：{{detailObj.feeamount}}元</van-col>
                    <van-col v-if="detailObj.latefees!=null" span='12'>违约金：{{detailObj.latefees}}元</van-col>
                    <van-col v-if="detailObj.feeshare!=''&&detailObj.feeshare!=null" span='12'>分摊金额：{{detailObj.feeshare}}元</van-col>
                    <van-col v-if="detailObj.shareamount!=''&&detailObj.shareamount!=null" span='12'>分摊用量：{{detailObj.shareamount}}</van-col>
                    <van-col span='12'>建筑面积：{{detailObj.struarea}}</van-col>
                </van-row>
            </div>
        </van-dialog>
        <!-- </van-popup> -->
        <!-- <div v-if="isShow3" style="font-size:14px;text-align:center;margin-top:15px;color:#e0e0e0">暂无数据</div> -->
        <van-empty v-if="isShow3" image="error" description="暂无数据" />
        <van-empty description="暂未绑定房屋，请先进行房屋绑定" v-if="isShow4">
            <span style="font-size:14px;color:blue" @click="openHoused">立即绑定房屋</span>
        </van-empty>
        <!-- <van-empty description="不存在交存明细或尚未绑定房屋。">
            <span style="font-size:14px;color:blue" @click="openHoused">立即绑定房屋</span>
        </van-empty> -->
        <!-- <van-button type="primary" @click="checkAll">{{isSure?'取消':'全选'}}</van-button>
        <van-button @click="ssss">测试</van-button>
        {{sbs}} -->
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data() {
        return{
            detailObj:{},
            CheckSize:false,
            openId:'',
            isShow4:false,
            appId:'',
            nonceStr:'',
            package:'',
            paySign:'',
            signType:'',
            timeStamp:'',
            // 
            isCancel:false,
            isAll:false,
            feeIds:[],
            isShow2:false,
            isShow3:false,
            refreshing:false,
            loading:false,
            error:false,
            finished:false,

            startnum:'',
            endnum:'',
            amount:'',
            price:'',
            isShow:false,
            iconfont:'',
            balance:'',
            houseguid:'',
            showContent:false,
            sbs:0,
            isSure:false,
            list:[],
            result:[],
            checked:true,
            activeNames:'',
            room:'',
            residentialshow:false,
            residentcolum:[],
            // 余额
            totalCost:'',// 费用合计
            feesPayable:'', // 应交费用
        }
    },
    beforeRouteLeave(to,from,next){
        this.$nextTick(()=>{
            if(this.showContent){
                this.showContent = false
                next(false)
            }else{
                next(true)
            }
        })
    },
    methods:{
        onSubmit(){
            console.log(111)
            this.$router.push({
                path:'/ConfirmPayment',
                query:{
                    balance:this.balance.toFixed(2),//余额
                    totalCost:this.totalCost.toFixed(2),//费用合计
                    feesPayable:this.feesPayable.toFixed(2),//应交费用
                    room:this.room,
                    houseguid:this.houseguid,
                    feeIds:this.feeIds
                }
            })
        },
        ClickAll(){
            console.log(this.CheckSize)
            if(this.CheckSize){
                this.result=[]
                this.list.forEach((item)=>{
                    this.result.push(item)
                })
                // 
                this.feeIds=[]
                this.result.forEach((item)=>{
                    this.feeIds.push(item.feerno)
                })
                // 
                let totalCost1=this.result.reduce((p,e)=>p+e.feeamount*10000+e.latefees*10000+e.feeshare*10000,0);
                this.totalCost=totalCost1/10000
                if(parseFloat(this.totalCost)-parseFloat(this.balance)>=0){
                    let feesPayable1 = parseFloat(this.totalCost)*10000-parseFloat(this.balance)*10000
                    this.feesPayable = feesPayable1/10000
                }else{
                    this.feesPayable=0
                }
            }else{
                this.result=[]
                // 
                this.feeIds=[]
                // 
                this.totalCost=0
                this.feesPayable=0
            }
        },
        openHoused(){
            this.$router.replace({
                path:'/AddNewAddress'
            })
        },
        // 获取小区
        getAddress(){
            let data={
                openid:VueCookie.get('openId')
                // openid:''
            }
            this.$postQuery('/HouseInfo/getBindHouseListByOpenId', data).then((response) => {
                // console.log(response)
                if(response.code==200){
                    if(response.data.length>0){
                        this.isShow4 = false
                        this.residentcolum = response.data
                        this.room=response.data[0].housename
                        this.houseguid = response.data[0].houseguid
                        this.balance = response.data[0].balance
                        this.getPayList()
                        // this.onLoad()
                    }else{
                        this.isShow4 = true
                        // this.isShow3 = false
                    }
                }
            })
        },
        // 获取代缴费列表
        getPayList(){
            let data={
                houseguid:this.houseguid
            }
            this.$postQuery('/FeeRecord/getUnPayList', data).then((response) => {
                // console.log(response)
                if(response.code==200){
                    this.list = response.data
                    if(this.list.length>0){
                        this.isShow2 = true
                        this.isShow3 = false
                        this.isShow4 = false
                    }else{
                        this.isShow2 = false
                        this.isShow3 = true
                        this.isShow4 = false
                    }
                    this.list.forEach((item)=>{
                        if(item.feename.indexOf('水')>-1){
                            item.iconfont='iconfont icon-shuifei blue'
                        }else if(item.feename.indexOf('电')>-1){
                            item.iconfont = 'iconfont icon-dianfei green'
                        }else if(item.feename.indexOf('车')>-1){
                            item.iconfont='iconfont icon-icon-test orange'
                        }else if(item.feename.indexOf('物业')>-1){
                            item.iconfont='iconfont icon-jiaofei yellow'
                        }else{
                            item.iconfont = 'iconfont icon-qita pink'
                        }
                    })
                    if(this.list[0].isElection==0||this.list[0].isElection==null){
                        this.isAll = false
                        this.isShow = false
                        this.feeIds=[]
                        this.result=[]
                        this.list.forEach((item)=>{
                            this.result.push(item)
                            this.feeIds.push(item.feerno)
                        })
                        // this.totalCost=0
                        // this.feesPayable=0
                        console.log(this.result,'wwwwww')
                        let totalCost1=this.result.reduce((p,e)=>p+e.feeamount*10000+e.latefees*10000+e.feeshare*10000,0);
                        this.totalCost = totalCost1/10000
                        console.log(this.totalCost,'dfdfdfdf')
                        if(parseFloat(this.totalCost)-parseFloat(this.balance)>=0){
                            let feesPayable1=parseFloat(this.totalCost)*10000-parseFloat(this.balance)*10000
                            this.feesPayable = feesPayable1/10000
                        }else{
                            this.feesPayable=0
                        }
                    }else if(this.list[0].isElection==1){
                        this.isAll = true
                        this.isShow = true
                        this.result=[]
                        this.totalCost=0
                        this.feesPayable=0
                    }
                }   
            })
        },
        onLoad(){
            let data={
                houseguid:this.houseguid
                // houseguid:''
            }
            this.$postQuery('/FeeRecord/getUnPayList', data).then((response) => {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(response.code==200){
                    this.list = response.data
                    if(this.list.length>0){
                        this.isShow3 = false
                        this.isShow4 = false
                        // this.isShow4 = false
                    }else{
                        this.isShow3 = true
                        this.isShow4 = false
                    }
                    // 加载状态结束
                    this.loading = false;
                    // // // 数据全部加载完成
                    if (this.list.length >= response.data.length) {
                        this.finished = true;
                    }
                    this.list.forEach((item)=>{
                        if(item.feename.indexOf('水')>-1){
                            item.iconfont='iconfont icon-shuifei blue'
                        }else if(item.feename.indexOf('电')>-1){
                            item.iconfont = 'iconfont icon-dianfei green'
                        }else if(item.feename.indexOf('车')>-1){
                            item.iconfont='iconfont icon-icon-test orange'
                        }else if(item.feename.indexOf('物业')>-1){
                            item.iconfont='iconfont icon-jiaofei yellow'
                        }else{
                            item.iconfont = 'iconfont icon-qita pink'
                        }
                    })
                    if(this.list[0].isElection==0){
                        this.isAll = false
                        this.isShow = false
                        this.result=[]
                        this.list.forEach((item)=>{
                            this.result.push(item)
                            this.feeIds.push(item.feerno)
                        })
                        // this.totalCost=0
                        // this.feesPayable=0
                        let totalCost1=this.result.reduce((p,e)=>p+e.feeamount*100+e.latefees*100,0);
                        this.totalCost = totalCost1/100
                        if(parseFloat(this.totalCost)-parseFloat(this.balance)>=0){
                            let feesPayable1=parseFloat(this.totalCost)*100-parseFloat(this.balance)*100
                            this.feesPayable = feesPayable1/100
                        }else{
                            this.feesPayable=0
                        }
                        // console.log(this.result)
                        // 在这调用那个点击事件
                    }else if(this.list[0].isElection==1){
                        this.isAll = true
                        this.isShow = true
                        this.result=[]
                        this.totalCost=0
                        this.feesPayable=0
                    }
                    
                //    this.feesPayable = parseFloat(this.totalCost)-parseFloat(this.balance)
                    // this.content = response.data.list
                    
                }else{
                    this.isShow3 = false

                }
            }).catch(()=>{
                this.error = true;
                this.loading = false
            })
        },
        // onRefresh(){
        //     // 清空列表数据
        //     this.finished = false;
        //     //重新加载数据
        //     this.loading = true;
        //     this.onLoad();
        // },
        // 默认全选事件
        SelectAll(){
            this.result.reduce((p,e)=>p+parseFloat(e.content),0);
        },
        // 
        openDetail(item){
            console.log(item)
            this.detailObj = item
            // this.startnum=item.startnum
            // this.endnum=item.endnum
            // this.amount=item.amount
            // this.price=item.price
            this.showContent = true
        },
        checkAll(){
            this.isCancel=!this.isCancel
            // console.log(this.list)
            if(this.isCancel){
                this.result=[]
                this.list.forEach((item)=>{
                    this.result.push(item)
                })
                // 
                this.feeIds=[]
                this.result.forEach((item)=>{
                    this.feeIds.push(item.feerno)
                })
                // 
                let totalCost1=this.result.reduce((p,e)=>p+e.feeamount*100+e.latefees*100,0);
                this.totalCost=totalCost1/100
                if(parseFloat(this.totalCost)-parseFloat(this.balance)>=0){
                    let feesPayable1 = parseFloat(this.totalCost)*100-parseFloat(this.balance)*100
                    this.feesPayable = feesPayable1/100
                }else{
                    this.feesPayable=0
                }
            }else{
                this.result=[]
                // 
                this.feeIds=[]
                // 
                this.totalCost=0
                this.feesPayable=0
            }
            // this.isSure = !this.isSure
            // if(this.isSure){
            //     this.result=[]
            //     this.list.forEach((item)=>{
            //         this.result.push(item)
            //     })
            //     this.sbs=this.result.reduce((p,e)=>p+parseFloat(e.content),0);
            // }else{
            //     this.result=[]
            //     this.sbs=0;
            // }
            // this.$refs.checkboxGroup.toggleAll(true);
            
        },
        //
        changeCheck(item){
            console.log(item)
            if(this.result.length==this.list.length){
                this.CheckSize = true
            }else{
                this.CheckSize = false
            }
            // this.result=[]
            this.feeIds=[]
            // console.log(this.result,'1111')
            // let result1 = this.result
            // console.log(result1)
            this.result.forEach((item)=>{
                this.feeIds.push(item.feerno)
            })
            // console.log(this.feeIds,'gfffff')
            let totalCost1=this.result.reduce((p,e)=>p+e.feeamount*10000+e.latefees*10000+e.feeshare*10000,0);
            this.totalCost=totalCost1/10000
            // console.log(this.totalCost)
            if(parseFloat(this.totalCost)-parseFloat(this.balance)>=0){
                // this.feesPayable = parseFloat(this.totalCost)-parseFloat(this.balance)
                let feesPayable1 = parseFloat(this.totalCost)*10000-parseFloat(this.balance)*10000
                this.feesPayable = feesPayable1/10000
            }else{
                this.feesPayable=0
            }
            
            // this.result.forEach((item)=>{
            //     item
            // })
            // this.sbs=this.result.reduce((p,e)=>p+parseFloat(e.content),0);
            // console.log(prices)
            // this.result.reduce((sbs, item) => this.sbs + item.content, 0)
        },
        onClickLeft() {
            history.go(-1);
        },
        onClickRight(){
            this.$router.push({
                path:'/HistoricalBills',
                query:{
                    houseguid:this.houseguid
                }
            })
        },
        residentcancel(){
            this.residentialshow = false
        },
        onConfirm(value){
            // console.log(value)
            this.houseguid = value.houseguid
            this.balance = value.balance
            this.room = value.housename
            this.residentialshow = false
            this.getPayList()
            // this.onLoad()
        },
        ssss(){
            console.log(this.result)
        },
        payMent(){
            if(this.feesPayable==0){
                this.$toast('余额足够，请联系物业公司抵扣！')
            }else{
                let data={
                    houseId:this.houseguid
                } 
                this.$postQuery('/RegionInfo/getPayTime', data).then((response) => {
                    // console.log(response)
                    if(response.code==200){
                        this.payMoney()
                    }else{
                        this.$toast(response.data)
                    }
                })
            }
        },
        payMoney(){
            // if(this.feesPayable==0){
            //     this.$toast('余额足够，请联系物业公司抵扣！')
            // }else{
                let data={
                    houseguid:this.houseguid,
                    openId:VueCookie.get('openId'),
                    amount:this.feesPayable,
                    feeIds:this.feeIds,
                    payReason:2
                }
                // console.log(data)
                this.$postJson('/FeeRecord/createOrder', data).then((response) => {
                    console.log(response)
                    if(response.code==200){
                        this.appId=response.data.appId
                        this.nonceStr=response.data.nonceStr
                        this.package=response.data.package
                        this.paySign=response.data.paySign
                        this.signType=response.data.signType
                        this.timeStamp=response.data.timeStamp

                        var _this=this;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', _this.imatePay(), false);
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', _this.imatePay());
                                document.attachEvent('onWeixinJSBridgeReady', _this.imatePay());
                            }
                        } else {
                            _this.imatePay()
                        }
                    }
                })
            // }
            
        },
        imatePay(){
            var _this=this;
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                appId:_this.appId,     //公众号ID，由商户传入     
                timeStamp:_this.timeStamp,     //时间戳，自1970年以来的秒数     
                nonceStr:_this.nonceStr,      //随机串     
                package:_this.package,
                signType:_this.signType,     //微信签名方式：
                paySign:_this.paySign, //微信签名 
            },
            function(res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router.replace({
                        path:'/'
                    })
                }
            })
        }
    },
    created(){
        this.getAddress()
        // this.openId=VueCookie.get('openId')
        // this.getPayList()

    }
}
</script>

<style scoped>
.green{
    color: #45b97c;
}
.yellow{
    color: rgb(104, 240, 217);
}
.orange{
    color:#f05b72;
}
.blue{
    color: rgb(141, 141, 211);
}
.pink{
    color: rgb(30, 221, 196);
}
.coolapseStyle{
    display: flex;
    align-items: center;
    /* justify-content: space-around; */
}
.clearBal>>>.van-cell--clickable{
    display: flex;
    align-items: center;
    /* background-color: #f7f2f2; */
    /* border-bottom:1px solid blue */
}
.clearBal{
    display: flex;
    align-items: center;
    /* display: table; */
    /* width: 100%; */
    /* height: 70px; */
    /* display: flex;
    align-items: center;
    width: 100%; */
}
.include_div{
    display: flex;
    align-items: center;
}
.houseS>>>.van-cell--clickable{
    background-color: #f4f1f1;
}
.houseS{
    background-color: #f4f1f1;
}
.houseS>>>.van-field__label{
    color: #1989fa !important;
}

.flex_button{
    background-color: #f2f2f2;
    position: fixed;
    /* bottom: 20px; */
    bottom: 0;
    width: 100%;
    /* border-top: 1px solid #e0e0e0; */
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: space-around; */
}
.dialogBilling>>>.van-dialog__header{
    padding-top:16px !important;
}
</style>